import React, {
  } from 'react';
  import { 
    Container, 
    Typography, 
    Button, 
    Card, 
    CardHeader, 
    IconButton,
    CardContent, } from '@mui/material';
  import { useNavigate } from 'react-router-dom';
  import SettingsStyles from './utils/SettingsStyles';
  import ComponentToolbar from '../main/ComponentToolbar';
  import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
  import {ReactComponent as InfoIcon} from '../resources/images/track2you/Icons_Info.svg';
  import {ReactComponent as SettingsIcon} from '../resources/images/track2you/Icons_Settings.svg';
  import {ReactComponent as DocumentIcon} from '../resources/images/track2you/Icons_Document.svg';


  
  const SettingsPage = () => {
    const classes = SettingsStyles();
    const navigate = useNavigate();
    
    return (
      <div className={classes.root}>
        <ComponentToolbar />

        <Container className={classes.mainContainer}>
            <Typography className={classes.leftTitle} variant="h6" component="h6">
            Definições Gerais
            </Typography>

            <div className={classes.mixerDiv}>
                <Button 
                    className={classes.mixerButon} 
                    variant="text">
                    <SettingsIcon className={classes.mixerIcon} />
                </Button>
            </div>
        </Container>

        <Card className={classes.settingsCard} >
            <CardHeader
            className={classes.settingsCardHeader}
            avatar={
                <DocumentIcon className={classes.settingsCardIcon} />
            }
            action={
                <IconButton aria-label="more">
                    <ArrowOutwardIcon />
                </IconButton>
            }
            title="Termos de Utilização"
            />
            <CardContent>
                <Typography className={classes.homeWorkAreaText} variant="body2" component="subtitle2">
                    Termos e condições para utilizar o Track2You App
                </Typography>
          </CardContent>
        </Card>

        <Container>
            <Typography className={classes.leftTitle} variant="h6" component="h6">
                Condições de utilização e Guia de instruções
            </Typography>

            <Typography className={classes.homeWorkAreaText} variant="body2" component="subtitle2">
                Consulte as condições e instruções gerais para o Track2You App
            </Typography>
        </Container>

        <Card className={classes.settingsCard} >
            <CardHeader
            className={classes.settingsCardHeader}
            avatar={
                <InfoIcon className={classes.settingsCardIcon} />
            }
            action={
                <IconButton aria-label="more">
                    <ArrowOutwardIcon />
                </IconButton>
            }
            title="Instruções de Utilização"
            />
            <CardContent>
                <Typography className={classes.homeWorkAreaText} variant="body2" component="subtitle2">
                    Instruções de utilização correta para o Track2You App
                </Typography>
          </CardContent>
        </Card>
      </div>
    );
  };
  
  export default SettingsPage;
  